import { compose, withStateHandlers, pure, withHandlers, setPropTypes, lifecycle } from 'recompose';
import { Props, propTypes, EnhancedProps, HandlerProps, StateHandlerProps } from './props';
import { State } from './state';
import Retransition from './component';

const timers: NodeJS.Timer[] = [];

export default compose<EnhancedProps, Props>(
  setPropTypes(propTypes),
  withStateHandlers<State, StateHandlerProps, EnhancedProps>(
    (props) => ({
      ...props,
      visible: false,
      didRender: false
    }),
    {
      onComplete: (state, props) => () => ({
        visible: false,
        timer: undefined
      }),
      onClickHandler: (state, props) => () => ({
        didRender: true,
        visible: true
      }),
      setTimer: (state, props) => (timer: NodeJS.Timer) => ({
        timer: timer
      })
    }
  ),
  lifecycle<EnhancedProps, {}>({
    componentWillUnmount() {
      if (this.props.timer) {
        clearTimeout(this.props.timer);
        const idx = timers.indexOf(this.props.timer);
        timers.splice(idx, 1);
      }
    }
  }),
  withHandlers<EnhancedProps, HandlerProps>({
    handleOnClick: (props) => async () => {
      if (props.await) {
        await new Promise(resolve => {
          const timer = setTimeout(resolve, props.duration);
          timers.push(timer);
          props.setTimer(timer);
        });
      }
      if (props.onClick) {
        props.onClick();
      }
    },
    handleOnComplete: (props) => () => {
      if (props.timer && timers.indexOf(props.timer) !== -1) {
        props.onComplete();
      }
    }
  }),
  pure,
)(Retransition);


// WEBPACK FOOTER //
// ./src/components/retransition/composer.ts